export default {
  sections: {
    address: 'Business address',
    address_help: 'Type the address your business is registered at. It is printed on your invoices.',
  },
  form: {
    legal_form: {
      label: 'Business type',
      help: 'A UG (haftungsbeschränkt) is a GmbH here, an e.K. a sole trader. For an OHG or KG, please contact support.',
      options: {
        sole_trader: 'Sole trader',
        gbr: 'GbR',
        gmbh: 'GmbH / UG',
      },
    },
    legal_name: {
      label: 'Registered business name',
      placeholder: 'Enter the registered business name',
      sole_trader_help: 'Leave empty if you trade under your own name',
    },
  },
  buttons: {
    next: 'Next',
  },
};
